import { useHistory } from 'react-router-dom';
import { isIOS, isMobile, isTablet, MobileView } from 'react-device-detect';
import { BlockMore } from '../HomePage';
import { WrapAuto } from '../Common';
import apiClient from '../../_utils/axios';
import Store from 'store';
import store from '../../store';
import StyleThum from '../designthum/StyleThum';
import { getStringByLang } from '../../libs/lang';

const isMobileView = isMobile && !(isIOS && isTablet);

export const StyleView = ({}) => {
  const history = useHistory();
  const mainStyleView = store.getState().main_style_view;

  const onViewPattern = () => {
    history.push({
      pathname: `/design/pattern`,
    });
  };

  const goStyle = (id) => {
    history.push({
      pathname: `/design/all/${id}`,
    });
  };

  if (!mainStyleView) {
    return <></>;
  }

  return (
    <div style={{ marginTop: '7vw' }}>
      <BlockMore onClick={onViewPattern} />
      <WrapAuto>
        {isMobileView
          ? store
              .getState()
              .main_style_view.slice(0, 6)
              .map((item, index) => (
                <StyleThum
                  key={`style-${index}`}
                  bg={`${process.env.REACT_APP_S3_BUCKET_DOMAIN}${item.style_main_img}`}
                  style={{ fontSize: 32 }}
                  title={getStringByLang(item.style_name_ko, item.style_name_en, item.style_name_jp)}
                  onClick={() => goStyle(item.style_id)}
                  hasbtn={false}
                />
              ))
          : store
              .getState()
              .main_style_view.slice(0, 6)
              .map((item, index) => (
                <StyleThum
                  key={`style-${index}`}
                  bg={`${process.env.REACT_APP_S3_BUCKET_DOMAIN}${item.style_main_img}`}
                  title={getStringByLang(item.style_name_ko, item.style_name_en, item.style_name_jp)}
                  onClick={() => goStyle(item.style_id)}
                  hasbtn={false}
                />
              ))}
      </WrapAuto>
    </div>
  );
};

export default StyleView;
